module.exports = __webpack_public_path__ + "d80c7566e32fe4ff9617020d78d7481b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-got-it.png
// module id = 2021
// module chunks = 4